import { useState } from 'react';
import { Button, Input } from 'semantic-ui-react';
import { errorInput, formatCurrency, s } from '../../components/helpers';
import styled from '@emotion/styled';
import Swal from 'sweetalert2/dist/sweetalert2';
import guestService from 'src/services/api/guest';
import { screenSizes } from 'src/assets/styles/Literals';
import { sillaValue } from './LegadoSelectChairs';
import { useEffect } from 'react';
import {
  isCaptchaRequired,
  useRecaptchaToken,
  RECAPTCHA_SECURITY_ERROR,
} from 'src/components/helpers/recaptchaUtils';
import GuestPlainData from '../../components/helpers/guests/GuestPlainData';
import { shouldLockGuestIdentity } from '../../components/helpers/guests/guestIdentity';

const DonationComp = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  background-color: white;
  padding: 20px 50px;
  .go-back-btn {
    align-self: flex-start;
    margin-left: 0;
    margin-bottom: 1rem;
    margin-right: auto;
    background: transparent;
    color: #1e3a8a;
    border: 1px solid #1e3a8a;
    border-radius: 16px;
    font-size: 0.85rem;
    font-weight: 500;
    padding: 4px 14px;
    cursor: pointer;
    z-index: 200;
  }
  h1 {
    font-size: 40px;
    padding: 20px 0;
    width: 100%;
    text-align: center;
  }
  .donate-btn-container {
    display: flex;
    gap: 10px;
    padding: 10px 0 30px 0;
    @media (max-width: ${screenSizes.tablet}) {
      flex-direction: column;
    }
    .donate-btn {
      background: #1e3a8a;
      color: white;
      font-size: 20px;
      font-weight: 600;
      padding: 10px 20px;
      border: none;
      border-radius: 32px;
      box-shadow: 0 2px 16px rgba(30, 58, 138, 0.12);
      cursor: pointer;
      z-index: 100;
      &.secondary {
        background: transparent;
        color: #1e3a8a;
        border: 1px solid #1e3a8a;
      }
    }
  }
  .donation-form {
    width: 80%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    .info {
      margin: 0 0 20px 0;
      .subtitle {
        font-size: 22px;
        margin: 0;
      }
      .note {
        font-size: 12px;
      }
    }
    form {
      display: flex;
      flex-wrap: wrap;
      width: 80%;
      justify-content: center;
      div {
        width: 100%;
      }
      .ui.input {
        width: 100%;
        margin: 10px 0;
      }
    }
  }

  .mini-chair-selector {
    display: flex;
    gap: 1rem;
    margin: 10px 0;
  }

  .mini-circle-btn {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #1e3a8a;
    color: white;
    font-size: 1.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    cursor: pointer;
    transition: background 0.2s;
    box-shadow: 0 2px 8px rgba(30, 58, 138, 0.08);
    user-select: none;
  }

  .mini-circle-btn:active {
    background: #2746b3;
  }

  .mini-circle-btn:disabled {
    background: #ccc;
    cursor: not-allowed;
  }

  .mini-chair-count {
    font-size: 1.5rem;
    color: #1e3a8a;
    font-weight: 700;
    min-width: 30px;
    text-align: center;
  }

  @media (max-width: ${screenSizes.tablet}) {
    width: 100%;
    .donation-form {
      width: 100%;
      form {
        width: 100%;
      }
    }
  }
`;

const LegadoPromiseForm = (props) => {
  const { category, inputs, setInputs, setCategory, refreshDonations, onGuestUpdated } = props;
  const [loading, set_loading] = useState(false);
  const [errorInputs, set_errorInputs] = useState({});
  const [commitmentType, setCommitmentType] = useState(null);
  const getCreateCaptchaToken = useRecaptchaToken('guest_create');
  const getUpdateCaptchaToken = useRecaptchaToken('guest_update');
  const identityLocked = shouldLockGuestIdentity(inputs);

  const handleInputs = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    setInputs({ ...inputs, [name]: value });
  };

  useEffect(() => {
    setInputs({
      ...inputs,
      chairsToCommit: parseInt(inputs.chairsToCommit || 0),
      valueToCommit: parseInt(inputs.chairsToCommit || 0) * sillaValue,
    });
    if (parseFloat(inputs.chairsToCommit).toString().split('.')[1]) {
      setCommitmentType('money');
    } else {
      setCommitmentType('chairs');
    }
  }, []);

  useEffect(() => {
    if (category === 'promiseFormValue') {
      setCommitmentType('money');
    }
  }, [category]);

  const verifyForm = () => {
    let mandatoryInputs = ['name', 'lastName', 'identification', 'email', 'phone'];

    let errorInputs = {};

    mandatoryInputs.forEach((input) => {
      errorInputs = errorInput({
        errorInputs,
        input: { name: input, value: inputs[input] },
      });
    });

    // Additional validation for identification length
    if (inputs.identification && inputs.identification.length <= 5) {
      errorInputs = errorInput({
        errorInputs: errorInputs,
        input: {
          name: 'identification',
          value: inputs.identification.length >= 5,
        },
      });
    }

    // Additional validation for phone length
    if (inputs.phone && inputs.phone.length <= 10) {
      errorInputs = errorInput({
        errorInputs: errorInputs,
        input: {
          name: 'phone',
          value: inputs.phone.length >= 10,
        },
      });
    }

    set_errorInputs(errorInputs);
    return Object.values(errorInputs).includes(true);
  };

  const submit = (e) => {
    e.preventDefault();
    if (verifyForm()) return Swal.fire('Error', 'Por favor llene todos los campos', 'error');
    createAttendant();
  };
  const createAttendant = async () => {
    const { id, name, lastName, phone, identification, email, chairsToCommit, valueToCommit } =
      inputs;

    const captchaRequired = isCaptchaRequired();
    const getToken = id ? getUpdateCaptchaToken : getCreateCaptchaToken;
    const captcha = await getToken({ skip: !captchaRequired });
    if (captchaRequired && !captcha) {
      Swal.fire(RECAPTCHA_SECURITY_ERROR);
      return;
    }

    const body = {
      name,
      lastName,
      phone,
      identification,
      email,
      first_register: 'legado',
      ...(captchaRequired ? { captcha } : {}),
    };

    if (commitmentType === 'chairs') {
      body.chairsToCommit = chairsToCommit;
    } else {
      body.chairsToCommit = valueToCommit / sillaValue;
    }

    set_loading(true);
    const persistGuest =
      id && identityLocked
        ? guestService.updateGuest(id, {
            identification,
            chairsToCommit: body.chairsToCommit,
            ...(captchaRequired ? { captcha } : {}),
          })
        : id
        ? guestService.updateGuest(id, body)
        : guestService.createGuest(body);
    persistGuest
      .then(() => {})
      .catch((error) => {
        if (error.response) console.error(error.response.data.message);
      })
      .finally(() => {
        setCategory('personalProgress');
        refreshDonations();
        set_loading(false);
      });
  };

  const handleBack = () => {
    let backTo = '';
    backTo = 'general';

    setCategory(backTo);
    setInputs({
      chairsToCommit: 0,
      valueToCommit: 0,
      chairs: 1,
      identification: inputs.identification,
      phone: inputs.phone,
    });
  };

  return (
    <DonationComp>
      <div className="donation-form">
        <div className="info">
          <button className="go-back-btn" onClick={handleBack}>
            Volver
          </button>
          <h1>Legado</h1>
          <p className="subtitle">Cada campo del formulario debe ser respondido</p>
        </div>
        <form onSubmit={submit}>
          {identityLocked ? (
            <div style={{ width: '100%', marginBottom: 20 }}>
              <GuestPlainData guest={inputs} onGuestUpdated={onGuestUpdated} />
            </div>
          ) : (
            <>
              <div>
                <label htmlFor="name" style={{ display: 'block' }}>
                  Nombre:
                </label>
                <Input
                  placeholder="Nombre completo"
                  name={'name'}
                  value={inputs.name}
                  style={{ padding: 0 }}
                  onChange={handleInputs}
                  className={`Registration__input Registration__input-${'name'} ${
                    errorInputs['name'] ? 'error' : ''
                  }`}
                />
              </div>
              <div>
                <label htmlFor="lastName" style={{ display: 'block' }}>
                  Apellidos:
                </label>
                <Input
                  placeholder="Apellidos"
                  name={'lastName'}
                  value={inputs.lastName}
                  style={{ padding: 0 }}
                  onChange={handleInputs}
                  className={`Registration__input Registration__input-${'lastName'} ${
                    errorInputs['lastName'] ? 'error' : ''
                  }`}
                />
              </div>
              <div>
                <label htmlFor="identification" style={{ display: 'block' }}>
                  Número de identificación:
                </label>
                <Input
                  placeholder="Número de identificación"
                  name={'identification'}
                  type="number"
                  value={inputs.identification}
                  style={{ padding: 0 }}
                  onChange={handleInputs}
                  className={`Registration__input Registration__input-${'identification'} ${
                    errorInputs['identification'] ? 'error' : ''
                  }`}
                />
              </div>
              <div>
                <label htmlFor="phone" style={{ display: 'block' }}>
                  Celular:
                </label>
                <Input
                  placeholder="Celular"
                  name={'phone'}
                  type="number"
                  value={inputs.phone}
                  style={{ padding: 0 }}
                  onChange={handleInputs}
                  className={`Registration__input Registration__input-${'phone'} ${
                    errorInputs['phone'] ? 'error' : ''
                  }`}
                />
              </div>
              <div>
                <label htmlFor="email" style={{ display: 'block' }}>
                  E-Mail:
                </label>
                <Input
                  placeholder="E-Mail"
                  type="email"
                  name={'email'}
                  value={inputs.email}
                  style={{ padding: 0 }}
                  onChange={handleInputs}
                  className={`Registration__input Registration__input-${'email'} ${
                    errorInputs['email'] ? 'error' : ''
                  }`}
                />
              </div>
            </>
          )}
          <div>
            <p>Deseas comprometerte con una cantidad específica de dinero o sillas?</p>
            <div className="donate-btn-container">
              <button
                className={`donate-btn ${commitmentType === 'chairs' ? '' : 'secondary'}`}
                onClick={(e) => {
                  e.preventDefault();
                  setCommitmentType('chairs');
                }}
              >
                Sillas
              </button>
              <button
                className={`donate-btn ${commitmentType === 'money' ? '' : 'secondary'}`}
                onClick={(e) => {
                  e.preventDefault();
                  setCommitmentType('money');
                }}
              >
                Dinero
              </button>
            </div>
            {commitmentType === 'chairs' && (
              <div>
                <label htmlFor="email" style={{ display: 'block', marginBottom: '10px' }}>
                  Sillas con las que me voy a comprometer:
                </label>
                <div className="mini-chair-selector">
                  <button
                    className="mini-circle-btn"
                    disabled={inputs.chairsToCommit <= 0}
                    onClick={(e) => {
                      e.preventDefault();
                      if (inputs.chairsToCommit > 0) {
                        handleInputs({
                          target: {
                            name: 'chairsToCommit',
                            value: inputs.chairsToCommit - 1,
                          },
                        });
                      }
                    }}
                    aria-label="Restar silla"
                  >
                    -
                  </button>
                  <span className="mini-chair-count">{inputs.chairsToCommit}</span>
                  <button
                    className="mini-circle-btn"
                    onClick={(e) => {
                      e.preventDefault();
                      handleInputs({
                        target: {
                          name: 'chairsToCommit',
                          value: inputs.chairsToCommit + 1,
                        },
                      });
                    }}
                    aria-label="Sumar silla"
                  >
                    +
                  </button>
                </div>
              </div>
            )}
            {commitmentType === 'money' && (
              <div>
                <label htmlFor="email" style={{ display: 'block' }}>
                  Valor con el que me voy a comprometer:
                </label>
                <Input
                  placeholder="Valor a comprometer"
                  type="number"
                  name={'valueToCommit'}
                  value={inputs.valueToCommit}
                  style={{ padding: 0 }}
                  min={0}
                  onChange={handleInputs}
                  className={`Registration__input Registration__input-${'valueToCommit'} ${
                    errorInputs['valueToCommit'] ? 'error' : ''
                  }`}
                />
              </div>
            )}
          </div>
          <div style={{ margin: '20px 0' }}>
            {!!inputs.userAllDonationsTotal && (
              <p>
                Haz donado un total de {formatCurrency(inputs.userAllDonationsTotal)} en pesos
                colombianos.
              </p>
            )}
            <p>
              Puedes donar en diferentes momentos y con distintos valores hasta completar las sillas
              que deseas donar. Puedes volver a esta sección en cualquier momento para consultar tus
              donaciones y agregar más.
            </p>
          </div>
          <div style={{ margin: '0 0 20px 0' }}>
            {commitmentType === 'chairs' && (
              <p>
                Te comprometes con {inputs.chairsToCommit} silla{s(inputs.chairsToCommit)} en total,
                que equivalen a {formatCurrency(inputs.chairsToCommit * sillaValue)} en pesos
                colombianos.
              </p>
            )}
            {commitmentType === 'money' && (
              <p>
                Te comprometes con {formatCurrency(inputs.valueToCommit || 0)} en pesos colombianos.
              </p>
            )}
          </div>
          <div>
            <Button
              onClick={submit}
              primary
              type="submit"
              disabled={
                loading || (!parseFloat(inputs.valueToCommit) && !parseFloat(inputs.chairsToCommit))
              }
              loading={loading}
            >
              Guardar mi compromiso
            </Button>
          </div>
        </form>
      </div>
    </DonationComp>
  );
};
export default LegadoPromiseForm;
